import { render, staticRenderFns } from "./ShippingPrice.vue?vue&type=template&id=10400ba4"
import script from "./ShippingPrice.vue?vue&type=script&lang=ts"
export * from "./ShippingPrice.vue?vue&type=script&lang=ts"
import style0 from "./ShippingPrice.vue?vue&type=style&index=0&id=10400ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports